import { SET_PROFILE } from "../actions/type";

const initialState = {
	profile: {
		email: "",
		name: "",
	},
};

export default (state = initialState, action) => {
	switch (action.type) {
		case SET_PROFILE:
			return {
				...state,
				profile: action.payload,
			};
		default:
			return state;
	}
};
